import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CrossIcon } from '@common_components/icons/cross.icon';

import Button from '@common_components/buttons/button.component';
import ConfirmationModal from '@common_components/modals/confirmationModal.component';

interface TopModalProps {
  icon: React.ReactNode;
  title: string;
  onClose: () => void;
  noConfirmationModal?: boolean;
}

const TopModal: React.FC<TopModalProps> = ( { icon, title, onClose, noConfirmationModal } ) => {
  const { t } = useTranslation();

  const [ isConfirmationOpen, setIsConfirmationOpen ] = useState( false );

  const handleClose = () => {
    if ( !noConfirmationModal ) {
      setIsConfirmationOpen( true );
    } else {
      onClose();
    }
  };

  const handleConfirmClose = () => {
    setIsConfirmationOpen( false );
    onClose();
  };

  const handleCancelClose = () => {
    setIsConfirmationOpen( false );
  };

  return (
    <>
      <div className="flex justify-between items-center bg-white-base border-b rounded-t-xl px-4">
        <div className="w-full flex-center gap-4 my-4">
          {icon}
          <h2 className="text-3xl font-comfortaa font-semibold">{ title }</h2>
        </div>
        <Button
          icon={
            <CrossIcon className="group-hover:rotate-[360deg] transition-transform duration-700" size={7} />
          }
          color="bg-transparent"
          colorHover="hover:bg-red-200"
          textColorHover="hover:text-red-base"
          hoverBorderColor="hover:border-transparent"
          textSize="text-xl"
          roundedRadius='rounded-xl'
          shadow="hover:shadow-md"
          onClick={handleClose}
        />
      </div>
      <ConfirmationModal
        isOpen={isConfirmationOpen}
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
        title={t( 'common:unsaved_changes' )}
        description={t( 'common:are_you_sure_you_want_to_close_unsaved_changes_will_be_lost' )}
      />
    </>
  );
};

export default TopModal;
